import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import CompaniesSettingsRow from '../../components/tables/admin/external/CompaniesTable';
import GnrSuppliersTable from '../../components/tables/admin/external/GnrSuppliersTable';
import QuarriesSettingsRow from '../../components/tables/admin/external/QuarriesSettingsRow';
import RentalsSettingsRow from '../../components/tables/admin/external/RentalsSettingsRow';
import SubContractorsSettingsRow from '../../components/tables/admin/external/SubContractorsSettingsRow';
import TempWorkersSettingsRow from '../../components/tables/admin/external/TempWorkersSettingsRow';
import TrucksCompaniesSettingsRow from '../../components/tables/admin/external/TrucksCompaniesSettingsRow';
import CustomTabs from '../../components/ui/CustomTabs';
import ToggleLine from '../../components/ui/ToggleLine';
import { localStorageKeys, permissionLevelEnum } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';

const ExternalAdminPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.ADMINEXTERNAL) || '0'));
    const [withUsageCount, setWithUsageCount] = useState<boolean>(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(capitalizeFirstLetter(t('external')));

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.ADMINEXTERNAL, newValue.toString());
    };

    return (
        <div className="fx-c h-100">
            <Header
                title={t('admin')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('external')) }]}
                subTitle={capitalizeFirstLetter(t('external'))}
                isDateVisible={false}
            >
                {user?.profileId.permsLevel === permissionLevelEnum.ADMIN && (
                    <ToggleLine title={capitalizeFirstLetter(t('showUsage'))} checked={withUsageCount} onChange={setWithUsageCount} />
                )}
            </Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[
                    t('gnrSuppliers'),
                    t('quarries'),
                    t('rentalsTypes'),
                    t('trucksCompanies'),
                    t('tempWorkers'),
                    t('subContractors'),
                    t('suppliers'),
                ]}
            />
            {selectedTab == 0 && <GnrSuppliersTable withUsageCount={withUsageCount} />}
            {selectedTab == 1 && <QuarriesSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 2 && <RentalsSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 3 && <TrucksCompaniesSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 4 && <TempWorkersSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 5 && <SubContractorsSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 6 && <CompaniesSettingsRow withUsageCount={withUsageCount} />}
        </div>
    );
};

export default ExternalAdminPage;
